
import React, { createContext, forwardRef, useContext, useEffect, useRef, useState, } from "react";
import { Row, Col, Typography } from './ot'
import { Info } from "lucide-react";
import SegmentedProgressBar from './segmented_progress_bar'

const ChartStackedCategoryBars = ({
    mode = "progress", // 'progress' | 'bar'
    title = "分類與建立方式分佈",
    haveTitle = true,
    data = [
        {
            title: "行銷",
            statistic_title: "文案",
            data: [
                { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
            ]
        },
        {
            title: "銷售",
            statistic_title: "文案",
            data: [
                { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
            ]
        },
        {
            title: "報告",
            statistic_title: "文案",
            data: [
                { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
            ]
        },
    ],
    /** 對應鍵：讓元件同時支援 {label,value} 或 {category,count} */
    keys = { label: "label", value: "value" },
    /** 直方圖用到的額外設定（可選） */
    bar = {
        height: 320,
        margin: { top: 20, right: 30, left: 20, bottom: 60 },
        barRadius: [4, 4, 0, 0],
        barColorVar: "var(--color-count)", // 你在 ChartContainer 提供的 CSS 變數
    },
}) => {
    return (<Row>
        {
            haveTitle ?? <Col span={24}>
                <Typography.Title level={3} className="text-sm font-medium mb-3 flex items-center">
                    <span className="text-indigo-700">{title}</span>
                    <Info className="h-3.5 w-3.5 ml-1 text-muted-foreground" />
                </Typography.Title>
            </Col>
        }
        <Col span={24}>
            <Row>
                {
                    data?.map((value) => {
                        return (<Col span={24}>
                            <SegmentedProgressBar
                                mode={mode}
                                keys={keys}
                                bar={bar}
                                {...value}
                            />
                        </Col>)
                    })
                }

            </Row>
        </Col>
        <Col span={24}>
        </Col>
    </Row>)
}
export default ChartStackedCategoryBars